// extracted by mini-css-extract-plugin
module.exports = {"content":"CheckoutWelcome_content___7NLu","contents":"CheckoutWelcome_contents__XUpUX"};